import type { AlertProps } from '@mui/material';
import type { Theme } from '@mui/material/styles';

//
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from './CustomIcons';

// ----------------------------------------------------------------------

const COLORS = ['info', 'success', 'warning', 'error'] as const;

const Alert = (theme: Theme) => {
  const isLight = theme.palette.mode === 'light';

  const rootStyle = (ownerState: AlertProps) => {
    const standardVariant = ownerState.variant === 'standard';

    const filledVariant = ownerState.variant === 'filled';

    const outlinedVariant = ownerState.variant === 'outlined';

    const colorStyle = COLORS.map((color) => ({
      ...(ownerState.severity === color && {
        // STANDARD
        ...(standardVariant && {
          '& .MuiAlert-icon': {
            color: theme.palette[color][isLight ? 'main' : 'light'],
          },
          backgroundColor: theme.palette[color][isLight ? 'lighter' : 'darker'],
          color: theme.palette[color][isLight ? 'darker' : 'lighter'],
        }),
        // FILLED
        ...(filledVariant && {
          backgroundColor: theme.palette[color].main,
          color: theme.palette[color].contrastText,
        }),
        // OUTLINED
        ...(outlinedVariant && {
          '& .MuiAlert-icon': {
            color: theme.palette[color].main,
          },
          border: `solid 1px ${theme.palette[color].main}`,
          color: theme.palette[color][isLight ? 'dark' : 'light'],
        }),
      }),
    }));

    return [...colorStyle];
  };

  return {
    MuiAlert: {
      defaultProps: {
        iconMapping: {
          error: <ErrorIcon />,
          info: <InfoIcon />,
          success: <SuccessIcon />,
          warning: <WarningIcon />,
        },
      },

      styleOverrides: {
        icon: {
          opacity: 1,
        },
        root: ({ ownerState }: { ownerState: AlertProps }) =>
          rootStyle(ownerState),
      },
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          marginBottom: theme.spacing(0.5),
        },
      },
    },
  };
};

export default Alert;
